import classNames from 'classnames'
import { DefineComponentProps } from 'utils'
import type { SVGAttributes } from 'vue'
import './LanguageIcon.scss'

interface LanguageIconProps extends Partial<SVGAttributes> {
  isAnimated?: boolean
}

export const LanguageIcon = defineComponent<LanguageIconProps>({
  props: DefineComponentProps<LanguageIconProps>(['isAnimated']),
  setup(props) {
    const durationTime = 1500

    const isLoading = ref(props.isAnimated)
    const startTime = ref(0)

    watch(
      () => props.isAnimated,
      (val) => {
        if (val) {
          startTime.value = Date.now()
          isLoading.value = true
        } else {
          const now = Date.now()

          const duration = now - startTime.value
          if (duration < durationTime) {
            setTimeout(() => {
              isLoading.value = false
            }, durationTime - duration)
          } else {
            isLoading.value = false
          }
        }
      },
      {
        immediate: true,
      },
    )

    return () => {
      return (
        <div
          class={classNames('language-icon-wrapper', {
            loading: isLoading.value,
          })}
          style={{ '--language-icon-duration': `${durationTime}ms` }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="var(--colors-text-base)"
              stroke-width="2"
            />
            <path d="M4 12H21M12 3C12 3 16 5.25 16 12C16 18.75 12 21 12 21C12 21 8 18.75 8 12C8 5.25 12 3 12 3Z" stroke="var(--colors-text-base)" stroke-width="2" />
          </svg>
        </div>
      )
    }
  },
})

export const PhoneLanguageIcon = defineComponent({
  setup() {
    return () => (
      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0_130757_208676" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <path
            d="M12 19.25C15.7279 19.25 18.75 16.2279 18.75 12.5C18.75 8.77208 15.7279 5.75 12 5.75C8.27208 5.75 5.25 8.77208 5.25 12.5C5.25 16.2279 8.27208 19.25 12 19.25Z"
            stroke="var(--colors-bg-icon-primary)"
            stroke-width="1.5"
          />
          <path
            d="M6 12.5H18.75M12 5.75C12 5.75 15 7.4375 15 12.5C15 17.5625 12 19.25 12 19.25C12 19.25 9 17.5625 9 12.5C9 7.4375 12 5.75 12 5.75Z"
            stroke="var(--colors-bg-icon-primary)"
            stroke-width="1.5"
          />
        </mask>
        <g mask="url(#mask0_130757_208676)">
          <rect y="0.5" width="24" height="24" fill="var(--colors-bg-icon-primary)" />
        </g>
      </svg>
    )
  },
})
